'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupName$$anon$74(name$7, outer) {
  this.c6x = null;
  this.c6x = name$7;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$GroupName$$anon$74 as $c_Lpresto_types$GroupName$$anon$74 };
$p = $c_Lpresto_types$GroupName$$anon$74.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupName$$anon$74;
/** @constructor */
function $h_Lpresto_types$GroupName$$anon$74() {
}
export { $h_Lpresto_types$GroupName$$anon$74 as $h_Lpresto_types$GroupName$$anon$74 };
$h_Lpresto_types$GroupName$$anon$74.prototype = $p;
$p.nD = (function(seq) {
  return seq.b1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$25) => {
    var this$2 = _$25.ja;
    var this$4 = this$2.toLowerCase();
    var this$3 = this.c6x;
    var s = this$3.toLowerCase();
    return ((this$4.indexOf(s) | 0) !== (-1));
  })));
});
var $d_Lpresto_types$GroupName$$anon$74 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupName$$anon$74, "presto.types$GroupName$$anon$74", ({
  a0A: 1,
  bN: 1
}));
export { $d_Lpresto_types$GroupName$$anon$74 as $d_Lpresto_types$GroupName$$anon$74 };
//# sourceMappingURL=presto.types$-Group-Name$$anon$74.js.map
